module.exports = __webpack_public_path__ + "img/B2.d4cf8390.jpg";